module.exports = __webpack_public_path__ + "media/dashboard/assets/images/inbox_icons/microsoft-badge-78a060ac4256f1c274c994e7e54c6108.svg";